
<div class="stepper flex flex-nowrap w-100" [ngClass]="{'overflow-x-hidden': !enableHorizontalScroll}">
  @for (step of steps; track step; let cnt = $count; let i = $index) {
    @if (_stepindex === i) {
      <div class="step min-w-full">
        <ng-container *ngTemplateOutlet="step.template"></ng-container>
      </div>
    }
  }
</div>
